import React from "react";
import { useTranslation } from "react-i18next";
import { LabelColumn, Row, ValueColumn } from "src/components/shared/Sidebar/SidebarTable";

interface Props {
    paymentType: string;
}

const PaymentType = ({ paymentType }: Props) => {
    const { t } = useTranslation();

    return (
        <Row>
            <LabelColumn>{t("ContinueDeal.VehicleInfo.paymentTypeLabel")}</LabelColumn>
            <ValueColumn>
                {
                    {
                        cash: t("ContinueDeal.VehicleInfo.cash"),
                        lease: t("ContinueDeal.VehicleInfo.lease"),
                        loan: t("ContinueDeal.VehicleInfo.finance"),
                    }[paymentType]
                }
            </ValueColumn>
        </Row>
    );
};

export default PaymentType;
